<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import type { TranslationFunctions } from '$i18n/i18n-types';
  import type ERAR from '$lib/erar/spec';
  import { trimTrailingZeroWithSign } from '$lib/utils/number';
  import { entries } from '$lib/utils/object';
  import { idToItem } from './stores';
  import UnityText from '../../components/unity-text.svelte';

  export let id: number;

  const customTranslationKey = [
    'hpRecover',
    'spRecover',
    'trapPower',
    'attackPowerByBuff',
    'defenseByBuff',
  ] as const;

  const ratioKeysWithoutRatio: (keyof ERAR.Schema.StaticItemOptions)[] = [
    'criticalStrikeChance',
    'criticalStrikeDamage',
    'cooldownReduction',
    'lifeSteal',
    'normalLifeSteal',
    'skillLifeSteal',
    'cooldownLimit',
    'preventCriticalStrikeDamaged',
    'uniqueCooldownLimit',
    'uniqueTenacity',
  ];

  const nonNumberOptions: (keyof ERAR.Schema.StaticItemOptions)[] = [
    'bulletCapacity',
    'bulletChargingInterval',
    'producers',
  ];

  $: item = $idToItem.get(id)!;
  $: numberOptions = entries(item.options).filter((entry) => {
    const [key, value] = entry!;
    if (nonNumberOptions.includes(key)) {
      return false;
    }
    return typeof value === 'number';
  });

  function isStatRatio(itemStatKey: string): boolean {
    if (itemStatKey === 'penetrationDefense') {
      return false;
    }

    return (
      itemStatKey.toLowerCase().includes('ratio') ||
      ratioKeysWithoutRatio.includes(itemStatKey as keyof ERAR.Schema.StaticItemOptions)
    );
  }

  function getItemStatName(LL: TranslationFunctions, key: string): string {
    if (customTranslationKey.includes(key as any)) {
      return LL.stats[key as (typeof customTranslationKey)[number]]();
    } else {
      const pascalizedKey = key.slice(0, 1).toUpperCase() + key.slice(1, key.length);
      return LL.er.stats[pascalizedKey as keyof TranslationFunctions['er']['stats']]({});
    }
  }
</script>

{#each numberOptions as option}
  {@const key = option?.[0] ?? ''}
  {@const value = option?.[1] ?? ''}
  {#if typeof value === 'number'}
    <span class:plus={value > 0} class:minus={value < 0}>
      {#if key === 'adaptiveForce' || key === 'adaptiveForcePerLevel'}
        {@const isPerLevel = key.endsWith('PerLevel')}
        {$LL.stats.adaptiveForce({
          attackPowerString: $LL.er.stats[isPerLevel ? 'AttackPowerByLv' : 'AttackPower'](),
          skillAmpString: $LL.er.stats[isPerLevel ? 'SkillAmpByLv' : 'SkillAmp'](),
          attackPower: value,
          skillAmp: value * 2,
        })}
      {:else}
        <UnityText taggedText={getItemStatName($LL, key)} />
        {#if isStatRatio(key)}
          {trimTrailingZeroWithSign(value * 100, 3)}%
        {:else}
          {trimTrailingZeroWithSign(value, 3)}
        {/if}
      {/if}
    </span>
  {/if}
  <!-- {:else}
  <slot name="empty" /> -->
{/each}
<!-- {#if item.options.bulletCapacity != undefined}
    
{/if} -->
